import { exportData } from "../exporters/exportFile";
import { exportSIMA } from "@earthbrain/sima";
/**
 * Converts the data into .sim format and exports.
 * @param simaInfo parsed SIMA data object
 * @param siteName site name
 * @param fileName target file name
 */
export function exportToSIMAFile(simaInfo, siteName, fileName) {
    console.log("SIMA data from obtained JSON: ", simaInfo);
    const simaData = exportSIMA(simaInfo, { siteName });
    exportData(simaData, fileName, ".sim");
}
//# sourceMappingURL=sima-exporter.js.map